<style lang="scss" scoped>
</style>
<template>
    <div>
        <compFormEdit
            ref="accountform"
            class="margin-top-15"
            :formdata="getTempCode"
            :rules="formRule"
            v-model="formData"
        ></compFormEdit>
        <div class="text-right">
            <vButton
                theme="primary"
                class="margin-right-10"
                @click="nextSubmit()"
                >{{$t('fbb.accountmanage.next_step', { defaultValue: '下一步' })}}</vButton
            >
            <vButton @click="close">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
        </div>
    </div>
</template>
<script>
import {
    HttpGetCusbilltemplateCode,
    HttpSaveCusTemplateCode,
} from "@/service/billing";
export default {
    props: ["temptype"],
    components: {
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            formData: {},
        };
    },
    created() {
        // console.log(this.temptype);
        this.getTemplateCode();
    },
    computed: {
        formRule() {
            return {
                ["*"]: {
                    required: true,
                    message: this.$t("global.common.fill_required"),
                },
                minimumBillableValue: {
                    trigger: "blur",
                    validator: (rule, value = "", callback) => {
                        if (!value) {
                            callback();
                        } else {
                            if (/[0-9]*/g.test(value) && Number(value) > 0) {
                                callback();
                            } else {
                                callback(new Error(this.$t('fbb.accountmanage.enter_more_than_zero', { defaultValue: "请输入大于0的正整数" })));
                            }
                        }
                    },
                },
            };
        },
        getTempCode() {
            // 仓储费模板
            if (this.temptype == 4) {
                return [
                    {
                        label: this.$t('fbb.accountmanage.template_code', { defaultValue: "模板Code" }),
                        tag: "vInput",
                        key: "code",
                        span: 24,
                        required: false,
                        query: true,
                    },
                    {
                        label: this.$t('fbb.accountmanage.template_name', { defaultValue: "模板名称" }),
                        tag: "vInput",
                        key: "name",
                        span: 24,
                    },
                    {
                        label: this.$t('fbb.accountmanage.cost_unit', { defaultValue: "计费单位" }),
                        tag: "vSelect",
                        key: "chargingUnit",
                        span: 24,
                        options: [
                            {
                                label: this.$t('fbb.accountmanage.volumn_lfyc', { defaultValue: "（体积）立方英尺" }),
                                value: 1,
                            },
                            {
                                label: this.$t('fbb.accountmanage.volumn_lfm', { defaultValue: "（体积）立方米" }),
                                value: 2,
                            },
                        ],
                    },
                    {
                        label: this.$t('fbb.accountmanage.min_cost_value', { defaultValue: "最低计费值" }),
                        tag: "vInput",
                        span: 24,
                        key: "minimumBillableValue",
                        // required: false,
                        // rule: {
                        //     trigger: 'blur',
                        //     validator: (rule, value = '', callback) => {
                        //         let flag = true;
                        //         if (/[0-9]+/g.test(value)) {
                        //             let num = Number(value);
                        //             if (!isNaN(num) && num > 0 ) {
                        //                 callback();
                        //             }
                        //             else {
                        //                 flag = false;
                        //             }

                        //         }
                        //         else {
                        //             flag = false;
                        //         }
                        //         if (!flag) callback(new Error('请输入大于0的数字'));
                        //     }
                        // }
                    },
                    {
                        label: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
                        tag: "vSelect",
                        key: "currency",
                        span: 24,
                        options: [{ value: "USD", label: "USD" }],
                        formItem: {
                            tip:
                                `<div class=color-error>${this.$t('fbb.accountmanage.warning_tip_1', { defaultValue: '币种一旦设置不可更改，请谨慎选择。' })}</div>`,
                        },
                    },
                    {
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        required: false,
                    },
                ];
            } else {
                return [
                    {
                        label: this.$t('fbb.accountmanage.template_code', { defaultValue: "模板Code" }),
                        tag: "vInput",
                        key: "code",
                        span: 24,
                        required: false,
                        query: true,
                    },
                    {
                        label: this.$t('fbb.accountmanage.template_name', { defaultValue: "模板名称" }),
                        tag: "vInput",
                        key: "name",
                        span: 24,
                    },
                    {
                        label: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
                        tag: "vSelect",
                        key: "currency",
                        span: 24,
                        options: [{ value: "USD", label: "USD" }],
                        formItem: {
                            tip:
                               `<div class=color-error>${this.$t('fbb.accountmanage.warning_tip_1', { defaultValue: '币种一旦设置不可更改，请谨慎选择。' })}</div>`,
                        },
                    },
                    {
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        required: false,
                    },
                ];
            }
        },
    },
    methods: {
        getTemplateCode() {
            HttpGetCusbilltemplateCode({
                type: this.temptype,
            }).then(
                (res) => {
                    this.$set(this.formData, "code", res.data);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async nextSubmit() {
            const valid = await this.$refs["accountform"].validate();
            // console.log(!valid)
            if (!valid) return;
            let { minimumBillableValue, chargingUnit, ...requestData } = {
                ...this.formData,
            };
            let meta = JSON.stringify({
                minimumBillableValue,
                chargingUnit
            });
            requestData = {
                ...requestData,
                meta
            };
            HttpSaveCusTemplateCode({
                organizationId: global.SYSID,
                type: this.temptype,
                ...requestData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$router.push({
                        name: "customerRateTemplateupdate",
                        params: { type: "edit" },
                        query: { id: res.data.id, temptype: res.data.type },
                    });
                    // this.$customermanageupdate
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            // sessionStorage.setItem('billcode', JSON.stringify(this.formData))
        },
        close() {
            this.$emit("on-close");
        },
    },
};
</script>
